import { VARIABLE_DATA_TYPE_OPTIONS } from "@/constants/rule-variables";

import type { Collection } from "@/components/settings/collections/collectionsApi";
import type { Option } from "../constants";

function collectionDataTypeName(dataTypeId: number): string | undefined {
	const match = VARIABLE_DATA_TYPE_OPTIONS.find((o) => Number(o.id) === Number(dataTypeId));
	return match?.label;
}

export function deriveCollectionOptions(items?: Collection[]): Option[] {
	if (!items?.length) return [];
	return items.map((item) => ({
		label: item.name,
		value: String(item.id),
		dataType: collectionDataTypeName(item.dataTypeId),
	}));
}

/** Loop decision UI label for the iterated collection entry (not persisted). */
export function formatCollectionCurrentValueLabel(collectionName: string): string {
	const trimmed = collectionName.trim();
	if (trimmed.includes("(Current Value)")) {
		return trimmed;
	} else {
		return `${trimmed} (Current Value)`;
	}
}

const VALUE_FROM_PREFIX = "A value from ";

/** Loop decision RHS pill / node display (not persisted). */
export function formatCollectionValueFromLabel(collectionName: string): string {
	const trimmed = collectionName.trim();
	if (trimmed.toLowerCase().startsWith(VALUE_FROM_PREFIX.toLowerCase())) {
		return trimmed;
	}
	return `${VALUE_FROM_PREFIX}${trimmed}`;
}

export function isCollectionLoopNode(data: { collectionId?: string | number | null }): boolean {
	return data.collectionId != null && String(data.collectionId).trim() !== "";
}
